<template>
  <div class="d-f ai-c">
    <div v-if="demoReviewersList.length === 0" class="p-r">
      <!-- <div class="tag br-pill bc-grey2 text-only">Not reviewed</div> -->
      <div class="mute">( Not reviewed )</div>
    </div>
    <div v-else class="d-f m-r-sm" v-for="reviewerId in demoReviewersList">
      <ImageWithInitials
        :src="allReviewers[reviewerId].profileImage"
        :name="allReviewers[reviewerId].name"
        size="33"
      />

      <span
        v-if="isDemoPlayedByReviewer(demoData, reviewerId)"
        class="tag p pill-mini br-pill ai-c d-f"
      >
        <IconBase :w="15" :h="15" view-box="0 0 15 15"> <IconPlay /> </IconBase>
        &nbsp;Played
      </span>

      <span
        v-if="isDemoRatedByReviewer(demoData, reviewerId)"
        class="tag p pill-mini br-pill ai-c d-f"
      >
        <IconBase :w="15" :h="15" view-box="0 0 15 15"> <IconStar /> </IconBase
        >&nbsp;{{ getAverageRating(demoData.ratings[reviewerId]) }}</span
      >

      <span
        v-if="isDemoSavedByReviewer(demoData, reviewerId)"
        class="tag p pill-mini br-pill ai-c d-f"
      >
        <IconBase :w="15" :h="15" view-box="0 0 15 15">
          <IconHeart />
        </IconBase>
      </span>

      <span
        v-if="isDemoRejectedByReviewer(demoData, reviewerId)"
        class="tag p pill-mini br-pill ai-c d-f"
      >
        <IconBase :w="15" :h="15" view-box="0 0 15 15">
          <IconCancelCircle />
        </IconBase>
      </span>

      <span
        v-if="isDemoCommentedByReviewer(demoData, reviewerId)"
        class="tag p pill-mini br-pill ai-c d-f"
      >
        <IconBase :w="15" :h="15" view-box="0 0 15 15">
          <IconMessage />
        </IconBase>
      </span>
    </div>
  </div>
</template>

<script>
import IconCancelCircle from "@/assets/icons/IconCancelCircle.vue";
import IconMessage from "@/assets/icons/IconMessage.vue";
import IconBase from "@/assets/icons/IconBase.vue";
import IconStar from "@/assets/icons/IconStar.vue";
import { mapGetters } from "vuex";
import IconHeart from "@/assets/icons/IconHeart.vue";
import * as Utils from "@/utils/demoUtils";
import ImageWithInitials from "@/components/misc/ImageWithInitials.vue";
import IconPlay from "@/assets/icons/IconPlay.vue";

export default {
  name: "DemoReviewsList",
  components: {
    IconPlay,
    ImageWithInitials,
    IconHeart,
    IconStar,
    IconBase,
    IconMessage,
    IconCancelCircle,
  },
  props: {
    demoData: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.$store.dispatch("cacheUserData", {
      uid: this.demoData.submittedBy,
    });
    this.$store.dispatch("cacheUserData", {
      uid: this.demoData.submittedTo,
      isLabel: true,
    });
  },
  methods: {
    isDemoCommentedByReviewer: Utils.isDemoCommentedByReviewer,
    isDemoSavedByReviewer: Utils.isDemoSavedByReviewer,
    isDemoRejectedByReviewer: Utils.isDemoRejectedByReviewer,
    getAverageRating: Utils.getAverageRating,
    isDemoRatedByReviewer: Utils.isDemoRatedByReviewer,
    isDemoPlayedByReviewer: Utils.isDemoPlayedByReviewer,
  },
  computed: {
    ...mapGetters(["getLabelReviewersByUid"]),

    allReviewers() {
      return this.getLabelReviewersByUid(this.demoData.submittedTo);
    },

    demoReviewersList() {
      return Object.keys(this.allReviewers).filter(
        (reviewer) =>
          Utils.isDemoPlayedByReviewer(this.demoData, reviewer) ||
          Utils.isDemoReviewedByReviewer(this.demoData, reviewer) ||
          Utils.isDemoRatedByReviewer(this.demoData, reviewer)
      );
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped></style>
